module.exports = (function (e) {
  const t = {};
  function n(r) {
    if (t[r]) return t[r].exports;
    const o = (t[r] = { i: r, l: !1, exports: {} });
    return e[r].call(o.exports, o, o.exports, n), (o.l = !0), o.exports;
  }
  return (
    (n.m = e),
    (n.c = t),
    (n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
    }),
    (n.r = function (e) {
      typeof Symbol !== 'undefined' &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(e, '__esModule', { value: !0 });
    }),
    (n.t = function (e, t) {
      if ((1 & t && (e = n(e)), 8 & t)) return e;
      if (4 & t && typeof e === 'object' && e && e.__esModule) return e;
      const r = Object.create(null);
      if (
        (n.r(r),
        Object.defineProperty(r, 'default', { enumerable: !0, value: e }),
        2 & t && typeof e !== 'string')
      )
        for (const o in e)
          n.d(
            r,
            o,
            function (t) {
              return e[t];
            }.bind(null, o)
          );
      return r;
    }),
    (n.n = function (e) {
      const t =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return n.d(t, 'a', t), t;
    }),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (n.p = ''),
    n((n.s = 2))
  );
})([
  function (e, t) {
    e.exports = require('react');
  },
  function (e, t) {
    e.exports = require('prop-types');
  },
  function (e, t, n) {
    n.r(t);
    const r = 'fslightbox-';
    function o() {
      const e = document.createElement('style');
      (e.className = 'fslightbox-styles'),
        e.appendChild(
          document.createTextNode(
            '.fslightbox-fade-in{animation:fslightbox-fade-in .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out{animation:fslightbox-fade-out .3s ease}.fslightbox-fade-in-strong{animation:fslightbox-fade-in-strong .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out-strong{animation:fslightbox-fade-out-strong .3s ease}@keyframes fslightbox-fade-in{from{opacity:.65}to{opacity:1}}@keyframes fslightbox-fade-out{from{opacity:.35}to{opacity:0}}@keyframes fslightbox-fade-in-strong{from{opacity:.3}to{opacity:1}}@keyframes fslightbox-fade-out-strong{from{opacity:1}to{opacity:0}}.fslightbox-absoluted{position:absolute;top:0;left:0}.fslightbox-cursor-grabbing{cursor:grabbing}.fslightbox-full-dimension{width:100%;height:100%}.fslightbox-open{overflow:hidden;height:100%}.fslightbox-flex-centered{display:flex;justify-content:center;align-items:center}.fslightbox-opacity-0{opacity:0!important}.fslightbox-opacity-1{opacity:1!important}.fslightbox-scrollbarfix{padding-right:17px}.fslightbox-transform-transition{transition:transform .3s}.fslightbox-container{font-family:Arial,sans-serif;position:fixed;top:0;left:0;background:linear-gradient(rgba(30,30,30,.9),#000 1810%);z-index:1000000000;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fslightbox-container *{box-sizing:border-box}.fslightbox-svg-path{transition:fill .15s ease;fill:#d1d2d2}.fslightbox-loader{display:block;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px}.fslightbox-loader div{box-sizing:border-box;display:block;position:absolute;width:54px;height:54px;margin:6px;border:5px solid;border-color:#999 transparent transparent transparent;border-radius:50%;animation:fslightbox-loader 1.2s cubic-bezier(.5,0,.5,1) infinite}.fslightbox-loader div:nth-child(1){animation-delay:-.45s}.fslightbox-loader div:nth-child(2){animation-delay:-.3s}.fslightbox-loader div:nth-child(3){animation-delay:-.15s}@keyframes fslightbox-loader{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.fslightbox-thumbs-loader{width:54px!important;height:54px!important}.fslightbox-thumbs-loader div{border-width:4px!important;width:44px!important;height:44px!important}.fslightbox-source-wrappers-container{transition:transform .2s linear;z-index:2}.fslightbox-source-wrappers-container-pinching{transition:none!important}.fslightbox-nav{height:45px;width:100%;transition:opacity .3s}.fslightbox-slide-number-container{display:flex;justify-content:center;align-items:center;position:relative;height:100%;font-size:15px;color:#d7d7d7;z-index:0;max-width:55px;text-align:left}.fslightbox-slide-number-container .fslightbox-flex-centered{height:100%}.fslightbox-slash{display:block;margin:0 5px;width:1px;height:12px;transform:rotate(15deg);background:#fff}.fslightbox-toolbar{position:absolute;z-index:3;right:0;top:0;height:100%;display:flex;background:rgba(35,35,35,.65)}.fslightbox-toolbar-button{height:100%;width:45px;cursor:pointer}.fslightbox-toolbar-button:hover .fslightbox-svg-path{fill:#fff}.fslightbox-slide-btn-container{display:flex;align-items:center;padding:12px 12px 12px 6px;position:absolute;top:50%;cursor:pointer;z-index:3;transform:translateY(-50%);transition:opacity .3s}@media (min-width:476px){.fslightbox-slide-btn-container{padding:22px 22px 22px 6px}}@media (min-width:768px){.fslightbox-slide-btn-container{padding:30px 30px 30px 6px}}.fslightbox-slide-btn-container:hover .fslightbox-svg-path{fill:#f1f1f1}.fslightbox-slide-btn{padding:9px;font-size:26px;background:rgba(35,35,35,.65)}@media (min-width:768px){.fslightbox-slide-btn{padding:10px}}@media (min-width:1600px){.fslightbox-slide-btn{padding:11px}}.fslightbox-slide-btn-container-previous{left:0}@media (max-width:475.99px){.fslightbox-slide-btn-container-previous{padding-left:3px!important}}.fslightbox-slide-btn-container-next{right:0;padding-left:12px!important;padding-right:3px!important}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-left:22px!important}}@media (min-width:768px){.fslightbox-slide-btn-container-next{padding-left:30px!important}}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-right:6px!important}}.fslightbox-down-event-detector{position:absolute;z-index:1}.fslightbox-slide-swiping-hoverer{z-index:4}.fslightbox-slideshow-bar{width:0;height:2px;z-index:4;opacity:0;background:#fff;transition:opacity .4s}.fslightbox-invalid-file-wrapper{font-size:26px;color:#eaebeb;margin:auto}.fslightbox-video{object-fit:cover}.fslightbox-source{position:relative;z-index:2;display:block;opacity:0;transform:translateZ(0);margin:auto;cursor:zoom-in;backface-visibility:hidden}.fslightbox-thumbs{position:absolute;bottom:0;left:0;width:100%;z-index:3;background:linear-gradient(180deg,rgba(0,0,0,0),#1e1e1e 100%);opacity:0;transition:opacity .2s;backface-visibility:hidden;padding:0 5px 12px 5px;height:114px}@media (min-width:992px){.fslightbox-thumbs{padding-bottom:13px;height:120px}}@media (min-width:1600px){.fslightbox-thumbs{padding-bottom:14px;height:126px}}.fslightbox-thumbs-active{opacity:1;z-index:3}.fslightbox-thumbs-inner{display:inline-flex;justify-content:flex-start;align-items:center;height:100%}.fslightbox-thumb-wrapper{position:relative;height:100%;margin:0 4px;opacity:0;transition:opacity .3s}.fslightbox-thumb-wrapper svg{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer;z-index:1}.fslightbox-thumb-wrapper path{fill:#fff}.fslightbox-thumb-wrapper-darkener{position:absolute;top:2px;left:2px;width:calc(100% - 4px);height:calc(100% - 4px);background:rgba(0,0,0,.4);cursor:pointer}.fslightbox-thumb{cursor:pointer;border-radius:1px;height:100%;width:auto!important;border:2px solid transparent;max-width:unset;max-height:unset}.fslightbox-thumb-active{border:2px solid #fff!important}.fslightbox-thumb-invalid{background:linear-gradient(to bottom,#0f0f0f,rgba(15,15,15,.5));display:inline-block;min-width:155px}.fslightbox-thumbs-cursorer{z-index:4;cursor:grabbing}.fslightbox-caption{position:absolute;bottom:0;left:50%;width:100%;background:linear-gradient(180deg,rgba(0,0,0,0),#1e1e1e 100%);transform:translateX(-50%);opacity:0;transition:opacity .2s;z-index:-1}.fslightbox-caption-inner{padding:25px;max-width:1200px;color:#eee;text-align:center;font-size:14px}@media (min-width:768px){.fslightbox-caption-inner{padding:30px 25px}}.fslightbox-caption-active{opacity:1;z-index:3}'
          )
        ),
        document.head.appendChild(e);
    }
    function i(e) {
      return (i =
        typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                typeof Symbol === 'function' &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? 'symbol'
                : typeof e;
            })(e);
    }
    (typeof document === 'undefined' ? 'undefined' : i(document)) ===
      'object' && o();
    const s = n(0);
    const a = n.n(s);
    const c = n(1);
    const u = n.n(c);
    const l = function (e) {
      const t = e.viewBox;
      const n = e.width;
      const o = e.height;
      const i = e.d;
      return a.a.createElement(
        'svg',
        {
          width: n,
          height: o,
          viewBox: t,
          xmlns: 'http://www.w3.org/2000/svg',
        },
        a.a.createElement('path', { className: `${r}svg-path`, d: i })
      );
    };
    function f(e) {
      const t = e.onClick;
      const n = e.viewBox;
      const r = e.width;
      const o = e.height;
      const i = e.d;
      const s = e.title;
      return a.a.createElement(
        'div',
        {
          className: 'fslightbox-toolbar-button fslightbox-flex-centered',
          title: s,
          onClick: t,
        },
        a.a.createElement(l, { viewBox: n, width: r, height: o, d: i })
      );
    }
    function d() {
      return (d =
        Object.assign ||
        function (e) {
          for (let t = 1; t < arguments.length; t++) {
            const n = arguments[t];
            for (const r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
    }
    function h(e, t) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, t) {
          let n =
            e == null
              ? null
              : (typeof Symbol !== 'undefined' && e[Symbol.iterator]) ||
                e['@@iterator'];
          if (n == null) return;
          let r;
          let o;
          const i = [];
          let s = !0;
          let a = !1;
          try {
            for (
              n = n.call(e);
              !(s = (r = n.next()).done) &&
              (i.push(r.value), !t || i.length !== t);
              s = !0
            );
          } catch (e) {
            (a = !0), (o = e);
          } finally {
            try {
              s || n.return == null || n.return();
            } finally {
              if (a) throw o;
            }
          }
          return i;
        })(e, t) ||
        (function (e, t) {
          if (!e) return;
          if (typeof e === 'string') return p(e, t);
          let n = Object.prototype.toString.call(e).slice(8, -1);
          n === 'Object' && e.constructor && (n = e.constructor.name);
          if (n === 'Map' || n === 'Set') return Array.from(e);
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return p(e, t);
        })(e, t) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        })()
      );
    }
    function p(e, t) {
      (t == null || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function m(e) {
      const t = e.fsLightbox;
      const n = t.componentsServices.toolbarButtons.fullscreen;
      const r = t.core.fullscreenToggler;
      const o = r.exitFullscreen;
      const i = r.enterFullscreen;
      const c = t.data.toolbarButtons.fullscreen;
      const u = c.enter;
      const l = c.exit;
      const p = h(Object(s.useState)(!1), 2);
      const m = p[0];
      const b = p[1];
      (n.get = function () {
        return m;
      }),
        (n.set = b);
      const g = m ? l : u;
      return a.a.createElement(f, { onClick: m ? o : i, ...g });
    }
    function b() {
      return (b =
        Object.assign ||
        function (e) {
          for (let t = 1; t < arguments.length; t++) {
            const n = arguments[t];
            for (const r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
    }
    function g(e, t) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, t) {
          let n =
            e == null
              ? null
              : (typeof Symbol !== 'undefined' && e[Symbol.iterator]) ||
                e['@@iterator'];
          if (n == null) return;
          let r;
          let o;
          const i = [];
          let s = !0;
          let a = !1;
          try {
            for (
              n = n.call(e);
              !(s = (r = n.next()).done) &&
              (i.push(r.value), !t || i.length !== t);
              s = !0
            );
          } catch (e) {
            (a = !0), (o = e);
          } finally {
            try {
              s || n.return == null || n.return();
            } finally {
              if (a) throw o;
            }
          }
          return i;
        })(e, t) ||
        (function (e, t) {
          if (!e) return;
          if (typeof e === 'string') return v(e, t);
          let n = Object.prototype.toString.call(e).slice(8, -1);
          n === 'Object' && e.constructor && (n = e.constructor.name);
          if (n === 'Map' || n === 'Set') return Array.from(e);
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return v(e, t);
        })(e, t) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        })()
      );
    }
    function v(e, t) {
      (t == null || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function x(e) {
      const t = e.fsLightbox;
      const n = t.componentsServices;
      const r = t.core.slideshowManager;
      const o = t.data.toolbarButtons.slideshow;
      const i = o.start;
      const c = o.pause;
      const u = g(Object(s.useState)(!1), 2);
      const l = u[0];
      const d = u[1];
      (n.startSlideshow = function () {
        return d(!0);
      }),
        (n.stopSlideshow = function () {
          return d(!1);
        });
      const h = l ? c : i;
      return a.a.createElement(f, { onClick: r.toggleSlideshow, ...h });
    }
    function y() {
      return (y =
        Object.assign ||
        function (e) {
          for (let t = 1; t < arguments.length; t++) {
            const n = arguments[t];
            for (const r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
    }
    const w = function (e) {
      const t = e.fsLightbox;
      const n = t.core;
      const r = n.clickZoomer;
      const o = r.zoomIn;
      const i = r.zoomOut;
      const s = n.lightboxCloser.close;
      const c = t.data.toolbarButtons;
      const u = t.props;
      const l = u.customToolbarButtons;
      const d = u.disableThumbs;
      const h = [];
      if (
        (d ||
          h.push(
            a.a.createElement(f, {
              onClick: t.core.thumbsToggler.toggleThumbs,
              ...c.thumbs,
              key: c.thumbs.title,
            })
          ),
        l)
      )
        for (
          let p = function (e) {
              const n = l[e];
              h.unshift(
                a.a.createElement(f, {
                  onClick() {
                    return n.onClick(t);
                  },
                  viewBox: n.viewBox,
                  width: n.width,
                  height: n.height,
                  d: n.d,
                  title: n.title,
                  key: n.title,
                })
              );
            },
            b = 0;
          b < l.length;
          b++
        )
          p(b);
      return a.a.createElement(
        'div',
        { className: 'fslightbox-toolbar' },
        h,
        a.a.createElement(f, { onClick: o, ...c.zoomIn }),
        a.a.createElement(f, { onClick: i, ...c.zoomOut }),
        a.a.createElement(x, { fsLightbox: t }),
        a.a.createElement(m, { fsLightbox: t }),
        a.a.createElement(f, { onClick: s, ...c.close })
      );
    };
    function S(e, t) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, t) {
          let n =
            e == null
              ? null
              : (typeof Symbol !== 'undefined' && e[Symbol.iterator]) ||
                e['@@iterator'];
          if (n == null) return;
          let r;
          let o;
          const i = [];
          let s = !0;
          let a = !1;
          try {
            for (
              n = n.call(e);
              !(s = (r = n.next()).done) &&
              (i.push(r.value), !t || i.length !== t);
              s = !0
            );
          } catch (e) {
            (a = !0), (o = e);
          } finally {
            try {
              s || n.return == null || n.return();
            } finally {
              if (a) throw o;
            }
          }
          return i;
        })(e, t) ||
        (function (e, t) {
          if (!e) return;
          if (typeof e === 'string') return A(e, t);
          let n = Object.prototype.toString.call(e).slice(8, -1);
          n === 'Object' && e.constructor && (n = e.constructor.name);
          if (n === 'Map' || n === 'Set') return Array.from(e);
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return A(e, t);
        })(e, t) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        })()
      );
    }
    function A(e, t) {
      (t == null || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    const T = function (e) {
      const t = e.fsLightbox;
      const n = t.componentsServices;
      const o = t.props.sources;
      const i = t.stageIndexes;
      const c = S(Object(s.useState)(i.current + 1), 2);
      const u = c[0];
      const l = c[1];
      n.setSlideNumber = function (e) {
        l(e);
      };
      const f = a.a.createRef();
      const d = a.a.createRef();
      return (
        Object(s.useEffect)(function () {
          d.current.offsetWidth > 55 &&
            (f.current.style.justifyContent = 'flex-start');
        }, []),
        a.a.createElement(
          'div',
          { ref: f, className: `${r}slide-number-container` },
          a.a.createElement(
            'div',
            { ref: d, className: 'fslightbox-flex-centered' },
            a.a.createElement('span', null, u),
            a.a.createElement('span', { className: `${r}slash` }),
            a.a.createElement('span', null, o.length)
          )
        )
      );
    };
    const L = function (e) {
      const t = e.fsLightbox;
      return a.a.createElement(
        'div',
        { ref: t.elements.nav, className: `${r}nav fslightbox-absoluted` },
        a.a.createElement(w, { fsLightbox: t }),
        t.props.sources.length > 1 && a.a.createElement(T, { fsLightbox: t })
      );
    };
    const C = function (e) {
      const t = e.additionalClassName;
      let n = (e.testId, `${r}loader`);
      return (
        t && (n += ` ${t}`),
        a.a.createElement(
          'div',
          { className: n },
          a.a.createElement('div', null),
          a.a.createElement('div', null),
          a.a.createElement('div', null),
          a.a.createElement('div', null)
        )
      );
    };
    function E(e, t) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, t) {
          let n =
            e == null
              ? null
              : (typeof Symbol !== 'undefined' && e[Symbol.iterator]) ||
                e['@@iterator'];
          if (n == null) return;
          let r;
          let o;
          const i = [];
          let s = !0;
          let a = !1;
          try {
            for (
              n = n.call(e);
              !(s = (r = n.next()).done) &&
              (i.push(r.value), !t || i.length !== t);
              s = !0
            );
          } catch (e) {
            (a = !0), (o = e);
          } finally {
            try {
              s || n.return == null || n.return();
            } finally {
              if (a) throw o;
            }
          }
          return i;
        })(e, t) ||
        (function (e, t) {
          if (!e) return;
          if (typeof e === 'string') return I(e, t);
          let n = Object.prototype.toString.call(e).slice(8, -1);
          n === 'Object' && e.constructor && (n = e.constructor.name);
          if (n === 'Map' || n === 'Set') return Array.from(e);
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return I(e, t);
        })(e, t) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        })()
      );
    }
    function I(e, t) {
      (t == null || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    const z = function (e) {
      const t = e.fsLightbox;
      const n = t.componentsServices.updateSourceDirectWrapperCollection;
      const r = t.core.stageManager.isSourceInStage;
      const o = t.elements;
      const i = o.sourceComponents;
      const c = o.sourceAnimationWrappers;
      const u = t.props.loadOnlyCurrentSource;
      const l = t.stageIndexes.current;
      const f = e.i;
      const d = E(Object(s.useState)(!1), 2);
      const h = d[0];
      const p = d[1];
      return (
        (n[f] = function () {
          p(!h);
        }),
        a.a.createElement(
          'div',
          { ref: c[f] },
          f === l || (!u && r(f)) ? i[f] : null
        )
      );
    };
    const W = function (e) {
      const t = e.fsLightbox;
      const n = e.i;
      return a.a.createElement(
        'div',
        { ref: t.elements.sourceEnhancementWrappers[n] },
        a.a.createElement(z, { fsLightbox: t, i: n })
      );
    };
    function O(e, t) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, t) {
          let n =
            e == null
              ? null
              : (typeof Symbol !== 'undefined' && e[Symbol.iterator]) ||
                e['@@iterator'];
          if (n == null) return;
          let r;
          let o;
          const i = [];
          let s = !0;
          let a = !1;
          try {
            for (
              n = n.call(e);
              !(s = (r = n.next()).done) &&
              (i.push(r.value), !t || i.length !== t);
              s = !0
            );
          } catch (e) {
            (a = !0), (o = e);
          } finally {
            try {
              s || n.return == null || n.return();
            } finally {
              if (a) throw o;
            }
          }
          return i;
        })(e, t) ||
        (function (e, t) {
          if (!e) return;
          if (typeof e === 'string') return M(e, t);
          let n = Object.prototype.toString.call(e).slice(8, -1);
          n === 'Object' && e.constructor && (n = e.constructor.name);
          if (n === 'Map' || n === 'Set') return Array.from(e);
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return M(e, t);
        })(e, t) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        })()
      );
    }
    function M(e, t) {
      (t == null || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    const P = function (e) {
      const t = e.fsLightbox;
      const n = e.i;
      const r = t.componentsServices.hideSourceLoaderCollection;
      const o = t.elements.sourceMainWrappers;
      const i = O(Object(s.useState)(!1), 2);
      const c = i[0];
      const u = i[1];
      return (
        (r[n] = function () {
          return u(!0);
        }),
        a.a.createElement(
          'div',
          {
            ref: o[n],
            className:
              'fslightbox-absoluted fslightbox-full-dimension fslightbox-flex-centered',
          },
          !c && a.a.createElement(C, null),
          a.a.createElement(W, { fsLightbox: t, i: n })
        )
      );
    };
    function j(e, t) {
      const n = e.sourcePointerProps;
      n.pointers[t.pointerId] = { screenX: t.screenX, screenY: t.screenY };
      const r = Object.keys(n.pointers).length;
      return (n.pointersCount = r), r <= 2;
    }
    function F(e) {
      for (
        var t = e.fsLightbox,
          n = t.core.sourcesPointerDown.listener,
          r = t.elements.sourceWrappersContainer,
          o = t.middleware,
          i = t.props.sources,
          s = [],
          c = 0;
        c < i.length;
        c++
      )
        s.push(a.a.createElement(P, { fsLightbox: t, i: c, key: c }));
      return a.a.createElement(
        'div',
        {
          className:
            'fslightbox-source-wrappers-container fslightbox-absoluted fslightbox-full-dimension',
          ref: r,
          onPointerDown: o(n, j),
        },
        s
      );
    }
    function k(e, t) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, t) {
          let n =
            e == null
              ? null
              : (typeof Symbol !== 'undefined' && e[Symbol.iterator]) ||
                e['@@iterator'];
          if (n == null) return;
          let r;
          let o;
          const i = [];
          let s = !0;
          let a = !1;
          try {
            for (
              n = n.call(e);
              !(s = (r = n.next()).done) &&
              (i.push(r.value), !t || i.length !== t);
              s = !0
            );
          } catch (e) {
            (a = !0), (o = e);
          } finally {
            try {
              s || n.return == null || n.return();
            } finally {
              if (a) throw o;
            }
          }
          return i;
        })(e, t) ||
        (function (e, t) {
          if (!e) return;
          if (typeof e === 'string') return N(e, t);
          let n = Object.prototype.toString.call(e).slice(8, -1);
          n === 'Object' && e.constructor && (n = e.constructor.name);
          if (n === 'Map' || n === 'Set') return Array.from(e);
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return N(e, t);
        })(e, t) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        })()
      );
    }
    function N(e, t) {
      (t == null || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    const B = function (e) {
      const t = e.fsLightbox.componentsServices;
      const n = k(Object(s.useState)(!1), 2);
      const o = n[0];
      const i = n[1];
      return (
        (t.showSlideSwipingHovererIfNotYet = function () {
          o || i(!0);
        }),
        (t.hideSlideSwipingHoverer = function () {
          i(!1);
        }),
        o &&
          a.a.createElement('div', {
            className: `${r}slide-swiping-hoverer fslightbox-full-dimension fslightbox-absoluted`,
          })
      );
    };
    function H(e) {
      const t = e.props.disableLocalStorage;
      if (!t) {
        const n = localStorage.getItem('fslightbox-scrollbar-width');
        if (n) return n;
      }
      const r = (function () {
        const e = document.createElement('div');
        const t = e.style;
        return (
          (t.visibility = 'hidden'),
          (t.width = '100px'),
          (t.msOverflowStyle = 'scrollbar'),
          (t.overflow = 'scroll'),
          e
        );
      })();
      const o = (function () {
        const e = document.createElement('div');
        return (e.style.width = '100%'), e;
      })();
      document.body.appendChild(r);
      const i = r.offsetWidth;
      r.appendChild(o);
      const s = o.offsetWidth;
      document.body.removeChild(r);
      const a = i - s;
      return (
        t || localStorage.setItem('fslightbox-scrollbar-width', a.toString()), a
      );
    }
    function R(e) {
      const t = e.core.lightboxOpener;
      const n = e.data;
      const r = e.props.openOnMount;
      document.getElementsByClassName('fslightbox-styles').length || o(),
        (n.scrollbarWidth = H(e)),
        r && t.initializeAndOpen();
    }
    const U = function (e) {
      const t = e.fsLightbox.elements.slideshowBar;
      return a.a.createElement('div', {
        className: `${r}slideshow-bar fslightbox-absoluted`,
        ref: t,
      });
    };
    function D(e, t) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, t) {
          let n =
            e == null
              ? null
              : (typeof Symbol !== 'undefined' && e[Symbol.iterator]) ||
                e['@@iterator'];
          if (n == null) return;
          let r;
          let o;
          const i = [];
          let s = !0;
          let a = !1;
          try {
            for (
              n = n.call(e);
              !(s = (r = n.next()).done) &&
              (i.push(r.value), !t || i.length !== t);
              s = !0
            );
          } catch (e) {
            (a = !0), (o = e);
          } finally {
            try {
              s || n.return == null || n.return();
            } finally {
              if (a) throw o;
            }
          }
          return i;
        })(e, t) ||
        (function (e, t) {
          if (!e) return;
          if (typeof e === 'string') return Y(e, t);
          let n = Object.prototype.toString.call(e).slice(8, -1);
          n === 'Object' && e.constructor && (n = e.constructor.name);
          if (n === 'Map' || n === 'Set') return Array.from(e);
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return Y(e, t);
        })(e, t) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        })()
      );
    }
    function Y(e, t) {
      (t == null || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function X(e) {
      const t = e.fsLightbox;
      const n = t.componentsServices;
      const r = t.core.thumbsSwipingDown.listener;
      const o = t.elements;
      const i = o.thumbsComponents;
      const c = o.thumbsInner;
      const u = D(Object(s.useState)(!1), 2);
      const l = u[0];
      const f = u[1];
      return (
        (n.updateThumbsInner = function () {
          f(!l);
        }),
        a.a.createElement(
          'div',
          { className: 'fslightbox-thumbs-inner', ref: c, onPointerDown: r },
          i
        )
      );
    }
    function Z(e, t) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, t) {
          let n =
            e == null
              ? null
              : (typeof Symbol !== 'undefined' && e[Symbol.iterator]) ||
                e['@@iterator'];
          if (n == null) return;
          let r;
          let o;
          const i = [];
          let s = !0;
          let a = !1;
          try {
            for (
              n = n.call(e);
              !(s = (r = n.next()).done) &&
              (i.push(r.value), !t || i.length !== t);
              s = !0
            );
          } catch (e) {
            (a = !0), (o = e);
          } finally {
            try {
              s || n.return == null || n.return();
            } finally {
              if (a) throw o;
            }
          }
          return i;
        })(e, t) ||
        (function (e, t) {
          if (!e) return;
          if (typeof e === 'string') return V(e, t);
          let n = Object.prototype.toString.call(e).slice(8, -1);
          n === 'Object' && e.constructor && (n = e.constructor.name);
          if (n === 'Map' || n === 'Set') return Array.from(e);
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return V(e, t);
        })(e, t) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        })()
      );
    }
    function V(e, t) {
      (t == null || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    const _ = function (e) {
      const t = e.fsLightbox.componentsServices;
      const n = Z(Object(s.useState)(!1), 2);
      const r = n[0];
      const o = n[1];
      return (
        (t.showThumbsCursorerIfNotYet = function () {
          r || o(!0);
        }),
        (t.hideThumbsCursorerIfShown = function () {
          r && o(!1);
        }),
        r
          ? a.a.createElement('div', {
              className:
                'fslightbox-thumbs-cursorer fslightbox-full-dimension fslightbox-absoluted',
            })
          : null
      );
    };
    function q(e, t) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, t) {
          let n =
            e == null
              ? null
              : (typeof Symbol !== 'undefined' && e[Symbol.iterator]) ||
                e['@@iterator'];
          if (n == null) return;
          let r;
          let o;
          const i = [];
          let s = !0;
          let a = !1;
          try {
            for (
              n = n.call(e);
              !(s = (r = n.next()).done) &&
              (i.push(r.value), !t || i.length !== t);
              s = !0
            );
          } catch (e) {
            (a = !0), (o = e);
          } finally {
            try {
              s || n.return == null || n.return();
            } finally {
              if (a) throw o;
            }
          }
          return i;
        })(e, t) ||
        (function (e, t) {
          if (!e) return;
          if (typeof e === 'string') return $(e, t);
          let n = Object.prototype.toString.call(e).slice(8, -1);
          n === 'Object' && e.constructor && (n = e.constructor.name);
          if (n === 'Map' || n === 'Set') return Array.from(e);
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return $(e, t);
        })(e, t) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        })()
      );
    }
    function $(e, t) {
      (t == null || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function Q(e) {
      const t = e.fsLightbox;
      const n = t.componentsServices;
      const r = t.data.isThumbing;
      const o = t.elements.thumbsContainer;
      const i = q(Object(s.useState)(!0), 2);
      const c = i[0];
      const u = i[1];
      n.hideThumbsLoader = function () {
        return u(!1);
      };
      let l = 'fslightbox-thumbs';
      return (
        r && (l += ' fslightbox-thumbs-active'),
        a.a.createElement(
          'div',
          { className: l, ref: o },
          a.a.createElement(_, { fsLightbox: t }),
          a.a.createElement(X, { fsLightbox: t }),
          c &&
            a.a.createElement(C, {
              testId: 'thumbs-loader',
              additionalClassName: 'fslightbox-thumbs-loader',
              key: 'loader',
            })
        )
      );
    }
    const J = function (e) {
      const t = e.fsLightbox;
      const n = e.index;
      const r = e.children;
      const o = t.data.isThumbing;
      const i = t.elements.captions;
      let s = 'fslightbox-caption';
      return (
        n !== t.stageIndexes.current ||
          o ||
          (s += ' fslightbox-caption-active'),
        a.a.createElement(
          'div',
          { ref: i[n], className: `${s} fslightbox-flex-centered` },
          a.a.createElement('div', { className: 'fslightbox-caption-inner' }, r)
        )
      );
    };
    const G = function (e) {
      const t = e.fsLightbox;
      const n = t.props.captions;
      return n
        ? n.map(function (e, n) {
            return (
              e && a.a.createElement(J, { fsLightbox: t, index: n, key: n }, e)
            );
          })
        : null;
    };
    function K(e) {
      const t = e.componentsServices.isLightboxOpenManager;
      const n = e.core;
      const r = n.lightboxCloser;
      const o = n.lightboxOpener;
      const i = n.slideIndexChanger;
      const s = e.data;
      const a = e.stageIndexes;
      (this.runTogglerUpdateActions = function () {
        t.get()
          ? r.close()
          : s.isInitialized
          ? o.open()
          : o.initializeAndOpen();
      }),
        (this.runCurrentStageIndexUpdateActionsFor = function (e) {
          e !== a.current && (t.get() ? i.jumpTo(e) : (a.current = e));
        });
    }
    function ee(e) {
      const t = e.core.lightboxUpdater;
      const n = (0, e.resolve)(K);
      t.handleUpdate = function (t) {
        const r = e.props;
        typeof r.sourceIndex === 'number'
          ? n.runCurrentStageIndexUpdateActionsFor(r.sourceIndex)
          : typeof r.source === 'string'
          ? n.runCurrentStageIndexUpdateActionsFor(r.sources.indexOf(r.source))
          : typeof r.slide === 'number' &&
            n.runCurrentStageIndexUpdateActionsFor(r.slide - 1),
          t.toggler !== r.toggler && n.runTogglerUpdateActions();
      };
    }
    function te(e) {
      let t;
      const n = e.props;
      let r = 0;
      const o = {};
      (this.getSourceTypeFromLocalStorageByUrl = function (e) {
        return t[e] ? t[e] : i(e);
      }),
        (this.handleReceivedSourceTypeForUrl = function (e, n) {
          !1 === o[n] &&
            (r--,
            e !== 'invalid' ? (o[n] = e) : delete o[n],
            r === 0 &&
              (!(function (e, t) {
                for (const n in t) e[n] = t[n];
              })(t, o),
              localStorage.setItem('fslightbox-types', JSON.stringify(t))));
        });
      var i = function (e) {
        r++, (o[e] = !1);
      };
      n.disableLocalStorage
        ? ((this.getSourceTypeFromLocalStorageByUrl = function () {}),
          (this.handleReceivedSourceTypeForUrl = function () {}))
        : (t = JSON.parse(localStorage.getItem('fslightbox-types'))) ||
          ((t = {}), (this.getSourceTypeFromLocalStorageByUrl = i));
    }
    function ne() {
      return (ne =
        Object.assign ||
        function (e) {
          for (let t = 1; t < arguments.length; t++) {
            const n = arguments[t];
            for (const r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
    }
    const re = function (e) {
      const t = e.fsLightbox;
      const n = t.collections.sourceLoadHandlers;
      const r = t.elements.sources;
      const o = t.props;
      const i = o.customAttributes;
      const s = o.sources;
      const c = e.i;
      return a.a.createElement('img', {
        onLoad: n[c].handleImageLoad,
        ref: r[c],
        className: 'fslightbox-source',
        src: s[c],
        ...(i && i[c] ? i[c] : {}),
      });
    };
    function oe() {
      return (oe =
        Object.assign ||
        function (e) {
          for (let t = 1; t < arguments.length; t++) {
            const n = arguments[t];
            for (const r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
    }
    const ie = function (e) {
      const t = e.fsLightbox;
      const n = t.collections.sourceLoadHandlers;
      const o = t.elements.sources;
      const i = t.props;
      const s = i.customAttributes;
      const c = i.sources;
      const u = t.timeout;
      const l = e.i;
      return (
        u(n[l].handleNotMetaDatedVideoLoad, 3e3),
        a.a.createElement(
          'video',
          {
            onLoadedMetadata: n[l].handleVideoLoad,
            className: `fslightbox-source ${r}video`,
            controls: !0,
            ref: o[l],
            ...(s && s[l] ? s[l] : {}),
          },
          a.a.createElement('source', { src: c[l] })
        )
      );
    };
    function se() {
      return (se =
        Object.assign ||
        function (e) {
          for (let t = 1; t < arguments.length; t++) {
            const n = arguments[t];
            for (const r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
    }
    const ae = function (e) {
      let t;
      const n = e.fsLightbox;
      const o = n.props;
      const i = o.customAttributes;
      const c = o.sources;
      const u = n.elements.sources;
      const l = n.collections.sourceLoadHandlers;
      const f = e.i;
      return (
        Object(s.useEffect)(l[f].handleYoutubeLoad),
        a.a.createElement('iframe', {
          ref: u[f],
          className: `fslightbox-source ${r}youtube-iframe`,
          src: `https://www.youtube.com/embed/${
            ((t = c[f]),
            `${
              t.match(
                /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
              )[2]
            }?enablejsapi=1`)
          }`,
          allowFullScreen: !0,
          ...(i && i[f] ? i[f] : {}),
        })
      );
    };
    const ce = function (e) {
      const t = e.fsLightbox;
      const n = t.collections.sourceLoadHandlers;
      const r = t.elements.sources;
      const o = t.props.sources;
      const { i } = e;
      Object(s.useEffect)(n[i].handleCustomLoad);
      const c = o[i].props.className;
      return a.a.cloneElement(o[i], {
        ref: r[i],
        className: c ? `${c} fslightbox-source` : 'fslightbox-source',
      });
    };
    const ue = function (e) {
      const t = e.fsLightbox;
      const n = t.componentsServices.hideSourceLoaderCollection;
      const o = t.elements.sourceAnimationWrappers;
      const i = t.props.initialAnimation;
      const c = e.i;
      return (
        Object(s.useEffect)(function () {
          n[c](), o[c].current.classList.add(i);
        }),
        a.a.createElement(
          'div',
          { className: `${r}invalid-file-wrapper fslightbox-flex-centered` },
          'Invalid source'
        )
      );
    };
    const le = function (e) {
      const t = e.fsLightbox;
      const n = t.core.thumbLoadHandler;
      const r = t.elements;
      const o = r.thumbs;
      const i = r.thumbsWrappers;
      const s = t.props.thumbsIcons;
      const c = t.stageIndexes.current;
      const u = e.src;
      const l = e.i;
      let f = 'fslightbox-thumb';
      c === l && (f += ' fslightbox-thumb-active');
      const d = s && s[l];
      return a.a.createElement(
        'div',
        { ref: i[l], className: 'fslightbox-thumb-wrapper' },
        d,
        d &&
          a.a.createElement('div', {
            className: 'fslightbox-thumb-wrapper-darkener',
          }),
        a.a.createElement('img', {
          ref: o[l],
          className: f,
          src: u,
          alt: u,
          onLoad: n.handleLoad,
        })
      );
    };
    const fe = function (e) {
      const t = e.fsLightbox;
      const n = t.core.thumbLoadHandler;
      const r = t.elements;
      const o = r.thumbs;
      const i = r.thumbsWrappers;
      const c = t.stageIndexes.current;
      const u = e.i;
      Object(s.useEffect)(n.handleLoad);
      let f = 'fslightbox-thumb fslightbox-flex-centered';
      return (
        u === c && (f += ' fslightbox-thumb-active'),
        a.a.createElement(
          'div',
          {
            ref: i[u],
            className: 'fslightbox-thumb-invalid fslightbox-thumb-wrapper',
          },
          a.a.createElement(
            'div',
            { ref: o[u], className: f },
            a.a.createElement(l, {
              viewBox: '0 0 30 30',
              height: '22px',
              width: '22px',
              d: 'M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16.212,8l-0.2,9h-2.024l-0.2-9 H16.212z M15.003,22.189c-0.828,0-1.323-0.441-1.323-1.182c0-0.755,0.494-1.196,1.323-1.196c0.822,0,1.316,0.441,1.316,1.196 C16.319,21.748,15.825,22.189,15.003,22.189z',
            })
          )
        )
      );
    };
    function de(e) {
      const t = e.componentsServices;
      const n = e.core.thumbsRenderDispatcher;
      const r = e.data;
      const o = e.elements.thumbsComponents;
      const i = e.props;
      const s = i.showThumbsOnMount;
      const c = i.sources;
      const u = i.thumbs;
      this.buildComponentForTypeAndIndex = function (i, f) {
        u && u[f]
          ? (o[f] = l(u, f))
          : (o[f] =
              i === 'image'
                ? l(c, f)
                : a.a.createElement(fe, { fsLightbox: e, i: f, key: f })),
          n.countBuiltThumb(),
          t.isLightboxOpenManager.get() &&
            (s || r.isThumbing) &&
            n.renderThumbsIfNotYetAndAllBuilt();
      };
      var l = function (t, n) {
        return a.a.createElement(le, {
          fsLightbox: e,
          src: t[n],
          i: n,
          key: n,
        });
      };
    }
    function he(e) {
      let t;
      const n = e.componentsServices;
      const r = n.isLightboxOpenManager;
      const o = n.updateSourceDirectWrapperCollection;
      const i = e.elements.sourceComponents;
      const s = e.props.disableThumbs;
      const c = e.resolve;
      s || (t = c(de)),
        (this.runActionsForSourceTypeAndIndex = function (n, c) {
          let u;
          switch (n) {
            case 'image':
              u = re;
              break;
            case 'video':
              u = ie;
              break;
            case 'youtube':
              u = ae;
              break;
            case 'custom':
              u = ce;
              break;
            default:
              u = ue;
          }
          (i[c] = a.a.createElement(u, { fsLightbox: e, i: c })),
            s || t.buildComponentForTypeAndIndex(n, c),
            r.get() && o[c]();
        });
    }
    function pe() {
      let e;
      let t;
      let n;
      const r = {
        isUrlYoutubeOne(e) {
          const t = document.createElement('a');
          return (t.href = e), t.hostname === 'www.youtube.com';
        },
        getTypeFromResponseContentType(e) {
          return e.slice(0, e.indexOf('/'));
        },
      };
      function o() {
        if (n.readyState !== 4) {
          if (n.readyState === 2) {
            let e;
            switch (
              r.getTypeFromResponseContentType(
                n.getResponseHeader('content-type')
              )
            ) {
              case 'image':
                e = 'image';
                break;
              case 'video':
                e = 'video';
                break;
              default:
                e = 'invalid';
            }
            (n.onreadystatechange = null), n.abort(), t(e);
          }
        } else t('invalid');
      }
      (this.setUrlToCheck = function (t) {
        e = t;
      }),
        (this.getSourceType = function (i) {
          if (r.isUrlYoutubeOne(e)) return i('youtube');
          (t = i),
            ((n = new XMLHttpRequest()).onreadystatechange = o),
            n.open('GET', e, !0),
            n.send();
        });
    }
    function me(e, t, n) {
      const r = e.props;
      const o = r.types;
      const i = r.type;
      const s = r.sources;
      const a = e.resolve;
      (this.getTypeSetByClientForIndex = function (e) {
        let t;
        return o && o[e] ? (t = o[e]) : i && (t = i), t;
      }),
        (this.retrieveTypeWithXhrForIndex = function (e) {
          const r = a(pe);
          r.setUrlToCheck(s[e]),
            r.getSourceType(function (r) {
              t.handleReceivedSourceTypeForUrl(r, s[e]),
                n.runActionsForSourceTypeAndIndex(r, e);
            });
        });
    }
    function be(e) {
      const t = Object.keys(e.pointers);
      const n = e.pointers[t[0]];
      const r = e.pointers[t[1]];
      return Math.hypot(n.screenX - r.screenX, n.screenY - r.screenY);
    }
    function ge(e, t) {
      const n = e.current.classList;
      n.contains(t) || n.add(t);
    }
    function ve(e) {
      const t = e.core.zoomer;
      const n = e.data;
      const r = e.elements;
      const o = e.sourcePointerProps;
      this.runPinchActions = function () {
        (o.isPinching = !0),
          (o.pinchedHypot = be(o)),
          ge(
            r.sourceWrappersContainer,
            'fslightbox-source-wrappers-container-pinching'
          ),
          n.zoom === 1 && t.startZooming();
      };
    }
    function xe(e) {
      let t;
      const n = e.core;
      const r = n.slideshowManager;
      const o = n.slideChangeFacade;
      const i = e.componentsServices;
      const s = e.elements.slideshowBar;
      const a = e.props;
      let c = !1;
      function u() {
        (c = !1),
          clearTimeout(t),
          s.current.classList.remove('fslightbox-opacity-1'),
          i.stopSlideshow();
      }
      (r.toggleSlideshow = function () {
        c
          ? u()
          : ((c = !0),
            i.startSlideshow(),
            s.current.classList.add('fslightbox-opacity-1'),
            (function e() {
              (s.current.style.transition = 'opacity .2s'),
                (s.current.style.width = '0px'),
                s.current.offsetWidth,
                (s.current.style.transition = `opacity .2s, width linear ${a.slideshowTime}ms`),
                (s.current.style.width = `${innerWidth}px`),
                (t = setTimeout(function () {
                  o.changeToNext(), e();
                }, a.slideshowTime));
            })());
      }),
        (r.resetSlideshow = function () {
          c && u();
        });
    }
    function ye(e, t) {
      const n = e.current.classList;
      n.contains(t) && n.remove(t);
    }
    function we(e) {
      const t = e.elements.captions;
      this.runSlideChangeActions = function (e, t) {
        n(e, 'remove'), n(t, 'add');
      };
      var n = function (e, n) {
        t[e].current && t[e].current.classList[n]('fslightbox-caption-active');
      };
    }
    function Se(e) {
      const t = e.core;
      const n = t.clickZoomer;
      const r = t.lightboxCloser;
      const o = t.fullscreenToggler;
      const i = t.slideChangeFacade;
      const s = t.slideshowManager;
      const a = t.thumbsToggler;
      const c = e.props.disableThumbs;
      this.listener = function (e) {
        if (e.code !== 'Space')
          switch (e.key) {
            case 'Escape':
              r.close();
              break;
            case 'ArrowLeft':
              i.changeToPrevious();
              break;
            case 'ArrowRight':
              i.changeToNext();
              break;
            case 't':
              c || a.toggleThumbs();
              break;
            case '+':
              n.zoomIn();
              break;
            case '-':
              n.zoomOut();
              break;
            case 'F11':
              e.preventDefault(), o.enterFullscreen();
          }
        else s.toggleSlideshow();
      };
    }
    function Ae(e) {
      const t = e.componentsServices;
      const n = e.core.pointeringBucket;
      const r = e.data;
      const o = e.elements.thumbsInner;
      const i = e.thumbsSwipingProps;
      this.runActions = function (e) {
        n.runSwipingMoveActionsForPropsAndEvent(i, e),
          (o.current.style.transform = `translateX(${
            r.thumbsTransform + i.swipedX
          }px)`),
          t.showThumbsCursorerIfNotYet();
      };
    }
    function Te(e) {
      const t = e.data;
      const n = e.resolve;
      const r = e.thumbsSwipingProps;
      const o = n(Ae);
      this.listener = function (e) {
        t.thumbsInnerWidth > innerWidth && r.isPointering && o.runActions(e);
      };
    }
    function Le(e) {
      const t = e.componentsServices;
      const n = e.data;
      const r = e.core;
      const o = r.slideIndexChanger;
      const i = r.thumbsTransformTransitioner;
      const s = r.pointeringBucket;
      const a = e.elements;
      const c = a.thumbsWrappers;
      const u = a.thumbsInner;
      const l = e.thumbsSwipingProps;
      function f(e) {
        (n.thumbsTransform = e),
          i.callActionWithTransition(function () {
            u.current.style.transform = `translateX(${e}px)`;
          });
      }
      (this.runNoSwipeActionsForEvent = function (e) {
        t.hideThumbsCursorerIfShown(), (l.isPointering = !1);
        for (let n = 0; n < c.length; n++)
          if (c[n].current && c[n].current.contains(e.target))
            return void o.jumpTo(n);
      }),
        (this.runActions = function () {
          if (
            (t.hideThumbsCursorerIfShown(),
            (n.thumbsTransform += l.swipedX),
            s.runSwipingTopActionsForPropsAndEvent(l),
            n.thumbsTransform > 0)
          )
            return f(0);
          n.thumbsTransform < innerWidth - n.thumbsInnerWidth - 9 &&
            f(innerWidth - n.thumbsInnerWidth - 9);
        });
    }
    function Ce(e) {
      const t = e.resolve;
      const n = e.thumbsSwipingProps;
      const r = t(Le);
      this.listener = function (e) {
        n.isPointering &&
          (n.swipedX ? r.runActions() : r.runNoSwipeActionsForEvent(e));
      };
    }
    function Ee(e) {
      const t = e.collections.sourceMainWrapperTransformers;
      const n = e.core.zoomer;
      const r = e.data;
      const o = e.sourcePointerProps;
      (this.runZoomingPinchActionsForHypot = function (e) {
        const t = e - o.pinchedHypot;
        let i = r.zoom + (t / Math.hypot(innerWidth, innerHeight)) * 10;
        i < 0.9 && (i = 0.9), n.zoomTo(i), (o.pinchedHypot = e);
      }),
        (this.translateSourceMainWrapperAtIndexUsingMethod = function (e, n) {
          t[e].translate(o.swipedX)[n]();
        });
    }
    function Ie(e) {
      const t = e.collections.sourceMainWrapperTransformers;
      const n = e.componentsServices;
      const r = e.core.pointeringBucket;
      const o = e.data;
      const i = e.resolve;
      const s = e.sourcePointerProps;
      const a = e.stageIndexes;
      const c = i(Ee);
      (this.runActions = function (e) {
        r.runSwipingMoveActionsForPropsAndEvent(s, e),
          n.showSlideSwipingHovererIfNotYet();
      }),
        (this.runPinchActions = function () {
          const e = be(s);
          s.pinchedHypot
            ? c.runZoomingPinchActionsForHypot(e)
            : (s.pinchedHypot = e);
        }),
        (this.runNormalSwipeActions = function () {
          c.translateSourceMainWrapperAtIndexUsingMethod(a.current, 'zero'),
            void 0 !== a.previous && s.swipedX > 0
              ? c.translateSourceMainWrapperAtIndexUsingMethod(
                  a.previous,
                  'negative'
                )
              : void 0 !== a.next &&
                s.swipedX < 0 &&
                c.translateSourceMainWrapperAtIndexUsingMethod(
                  a.next,
                  'positive'
                );
        }),
        (this.runZoomSwipeActions = function (e) {
          (s.swipedX = (e.screenX - s.downScreenX) / o.zoom),
            (s.swipedY = (e.screenY - s.downScreenY) / o.zoom),
            t[a.current]
              .translate(s.upSwipedX + s.swipedX, s.upSwipedY + s.swipedY)
              .zero();
        });
    }
    function ze(e) {
      const t = e.data;
      const n = e.props.sources;
      const r = e.resolve;
      const o = e.sourcePointerProps;
      const i = r(Ie);
      this.listener = function (e) {
        if (o.isPinching) return i.runActions(e), void i.runPinchActions();
        o.pointersCount !== 2 &&
          (i.runActions(e),
          t.zoom === 1
            ? n.length === 1
              ? (o.swipedX = 1)
              : i.runNormalSwipeActions()
            : i.runZoomSwipeActions(e));
      };
    }
    function We(e) {
      const t = e.collections.sourceMainWrapperTransformers;
      const n = e.core;
      const r = n.slideIndexChanger;
      const o = n.clickZoomer;
      const i = e.data;
      const s = e.elements.sourceMainWrappers;
      const a = e.sourcePointerProps;
      const c = e.stageIndexes;
      (this.runPositiveSwipedXActions = function () {
        void 0 === c.previous || (u('positive'), r.changeTo(c.previous)),
          u('zero');
      }),
        (this.runNegativeSwipedXActions = function () {
          void 0 === c.next || (u('negative'), r.changeTo(c.next)), u('zero');
        }),
        (this.saveCurrentSourceMainWrapperPosition = function () {
          (a.upSwipedX = t[c.current].getTranslateX()),
            (a.upSwipedY = t[c.current].getTranslateY());
        }),
        (this.runSourceDownEventTargetActions = function () {
          i.zoom <= 1 ? o.zoomIn() : o.zoomOut();
        });
      var u = function (e) {
        s[c.current].current.classList.add('fslightbox-transform-transition'),
          t[c.current][e]();
      };
    }
    function Oe(e) {
      const t = e.componentsServices;
      const n = e.core;
      const r = n.lightboxCloser;
      const o = n.pointeringBucket;
      const i = e.data;
      const s = e.elements.sourceWrappersContainer;
      const a = e.resolve;
      const c = e.sourcePointerProps;
      const u = a(We);
      (this.runActions = function () {
        t.hideSlideSwipingHoverer(),
          (c.isPinching = !1),
          (c.pinchedHypot = 0),
          o.runSwipingTopActionsForPropsAndEvent(c),
          ye(s, 'fslightbox-source-wrappers-container-pinching');
      }),
        (this.runSwipeActions = function () {
          i.zoom === 1
            ? c.swipedX > 0
              ? u.runPositiveSwipedXActions()
              : u.runNegativeSwipedXActions()
            : u.saveCurrentSourceMainWrapperPosition();
        }),
        (this.runNoSwipeActions = function () {
          c.isSourceDownEventTarget
            ? u.runSourceDownEventTargetActions()
            : r.close();
        });
    }
    function Me(e) {
      const t = e.data;
      const n = e.resolve;
      const r = e.sourcePointerProps;
      const o = e.core.zoomer;
      const i = n(Oe);
      this.listener = function (e) {
        (r.pointers = {}),
          r.isPointering &&
            (r.isPinching ||
              (r.swipedX ? i.runSwipeActions() : i.runNoSwipeActions()),
            i.runActions(e),
            t.zoom < 1 && (o.zoomTo(1), o.endZooming()));
      };
    }
    function Pe(e) {
      return e.sourcePointerProps.isPointering;
    }
    function je(e) {
      const t = e.core.inactiver;
      const n = e.middleware;
      const r = e.props;
      const o = e.resolve;
      const i = o(ze);
      const s = o(Me);
      const a = o(Te);
      const c = o(Ce);
      (this.moveListener = function (e) {
        t.listener(e),
          n(n(i.listener, j), Pe)(e),
          r.disableThumbs || a.listener(e);
      }),
        (this.upListener = function (e) {
          s.listener(e), r.disableThumbs || c.listener(e);
        });
    }
    function Fe(e) {
      const t = e.core.zoomer;
      const n = e.data;
      this.listener = function (e) {
        if (n.zoom === 1) {
          if (e.deltaY > 0) return;
          t.startZooming();
        }
        const r = 0.1 * n.zoom;
        let o = n.zoom;
        e.deltaY < 0 ? (o += r) : (o -= r) < 1 && (o = 1),
          t.zoomTo(o),
          o === 1 && t.endZooming();
      };
    }
    function ke(e) {
      return !e.sourcePointerProps.isPointering;
    }
    function Ne(e) {
      let t;
      const n = e.core;
      const r = n.inactiver;
      const o = n.globalEventsController;
      const i = n.windowResizeActioner;
      const s = e.middleware;
      const a = e.resolve;
      const c = a(je);
      const u = a(Se);
      const l = a(Fe);
      (o.addListeners = function () {
        document.addEventListener('pointerdown', r.listener),
          document.addEventListener('pointermove', c.moveListener),
          document.addEventListener('pointerup', c.upListener),
          addEventListener('resize', i.runActions),
          document.addEventListener('keydown', u.listener);
        let e;
        const n =
          ((e = !1),
          function () {
            return (
              !e &&
              ((e = !0),
              requestAnimationFrame(function () {
                e = !1;
              }),
              !0)
            );
          });
        (t = s(
          (t = function (e) {
            return n() && l.listener(e);
          }),
          ke
        )),
          document.addEventListener('wheel', t);
      }),
        (o.removeListeners = function () {
          document.removeEventListener('pointerdown', r.listener),
            document.removeEventListener('pointermove', c.moveListener),
            document.removeEventListener('pointerup', c.upListener),
            removeEventListener('resize', i.runActions),
            document.removeEventListener('keydown', u.listener),
            document.removeEventListener('wheel', t);
        });
    }
    function Be(e) {
      const t = e.data;
      const n = e.elements;
      const r = n.captions;
      const o = n.slideButtonPrevious;
      const i = n.slideButtonNext;
      const s = n.thumbsContainer;
      const a = e.stageIndexes;
      (this.runOpacity0ActionUsingMethod = function (e) {
        o.current &&
          (o.current.classList[e]('fslightbox-opacity-0'),
          i.current.classList[e]('fslightbox-opacity-0'));
      }),
        (this.runActiveEnhancementActionUsingMethod = function (e) {
          t.isThumbing
            ? s.current.classList[e]('fslightbox-thumbs-active')
            : r[a.current].current &&
              r[a.current].current.classList[e]('fslightbox-caption-active');
        });
    }
    function He(e) {
      let t;
      let n;
      let r;
      const o = e.data;
      const i = e.elements;
      const s = i.sourceEnhancementWrappers;
      const a = i.sources;
      const c = i.thumbsContainer;
      const u = o.captionHeights;
      const l = o.notThumbedSourceEnhancementWrapperScales;
      const f = o.notThumbedSourceEnhancementWrapperTranslatesY;
      (this.setUpThumbedEnhancementWrapperTransform = function () {
        (t = c.current.offsetHeight),
          (n = o.thumbedSourceEnhancementWrapperTranslateY),
          (r = `translateY(${n}px) scale(${o.thumbedSourceEnhancementWrapperScale})`);
      }),
        (this.setUpNotThumbedEnhancementWrapperTransformAtIndex = function (e) {
          (t = u[e]), (n = f[e]), (r = `translateY(${n}px) scale(${l[e]})`);
        }),
        (this.ifSourceIsLoadedTransformEnhancementWrapperAtIndex = function (
          e
        ) {
          a[e].current &&
            (innerWidth < innerHeight &&
            a[e].current.offsetWidth > a[e].current.offsetHeight + t
              ? (s[e].current.style.transform = `translateY(${
                  n / 2
                }px) scale(1)`)
              : (s[e].current.style.transform = r));
        });
    }
    function Re(e) {
      let t;
      let n;
      let r;
      (n = (t = e).core.classFacade),
        (r = t.elements),
        (n.removeFromEachElementClassIfContains = function (e, t) {
          for (let n = 0; n < 100; n++)
            for (let o = 0; o < r[e].length; o++) ye(r[e][o], t);
        }),
        (function (e) {
          const t = e.core;
          const n = t.clickZoomer;
          const r = t.zoomer;
          const o = e.data;
          const i = e.elements.sourceWrappersContainer;
          const s = e.getQueuedAction;
          const a = e.props.zoomIncrement;
          const c = s(function () {
            ye(i, 'fslightbox-transform-transition');
          }, 300);
          function u() {
            o.zoom === 1 && r.startZooming();
          }
          function l(e) {
            ge(i, 'fslightbox-transform-transition'), r.zoomTo(e), c();
          }
          (n.zoomIn = function () {
            u(), l(o.zoom + a);
          }),
            (n.zoomOut = function () {
              o.zoom - a <= 1
                ? o.zoom !== 1 && (l(1), r.endZooming())
                : (u(), l(o.zoom - a), o.zoom === 1 && r.endZooming());
            });
        })(e),
        (function (e) {
          const t = e.core.eventsDispatcher;
          const n = e.props;
          t.dispatch = function (t) {
            n[t] && n[t](e);
          };
        })(e),
        (function (e) {
          const t = e.componentsServices.toolbarButtons.fullscreen;
          const n = e.core.fullscreenToggler;
          (n.enterFullscreen = function () {
            t.set(!0);
            const e = document.documentElement;
            e.requestFullscreen
              ? e.requestFullscreen()
              : e.mozRequestFullScreen
              ? e.mozRequestFullScreen()
              : e.webkitRequestFullscreen
              ? e.webkitRequestFullscreen()
              : e.msRequestFullscreen && e.msRequestFullscreen();
          }),
            (n.exitFullscreen = function () {
              t.set(!1),
                document.exitFullscreen
                  ? document.exitFullscreen()
                  : document.mozCancelFullScreen
                  ? document.mozCancelFullScreen()
                  : document.webkitExitFullscreen
                  ? document.webkitExitFullscreen()
                  : document.msExitFullscreen && document.msExitFullscreen();
            });
        })(e),
        Ne(e),
        (function (e) {
          const t = e.core.inactiver;
          const n = e.data;
          const r = e.elements;
          const o = r.nav;
          const i = r.slideButtonPrevious;
          const s = r.slideButtonNext;
          const a = r.thumbsContainer;
          const c = e.getQueuedAction;
          const u = e.props.UIFadeOutTime;
          let l = !1;
          const f = c(function () {
            (l = !0), d(h);
          }, u);
          f(),
            (t.listener = function () {
              f(), l && (d(p), (l = !1));
            });
          var d = function (e) {
            try {
              e(o),
                n.zoom === 1 && i.current && (e(i), e(s)),
                n.isThumbing && e(a);
            } catch (e) {}
          };
          var h = function (e) {
            e.current.classList.add('fslightbox-opacity-0');
          };
          var p = function (e) {
            e.current.classList.remove('fslightbox-opacity-0');
          };
        })(e),
        (function (e) {
          const t = e.core;
          const n = t.lightboxCloser;
          const r = t.lightboxCloseActioner;
          n.close = function () {
            r.isLightboxFadingOut || r.runActions();
          };
        })(e),
        (function (e) {
          const t = e.componentsServices;
          const n = t.isLightboxOpenManager;
          const r = t.toolbarButtons.fullscreen;
          const o = e.core;
          const i = o.eventsDispatcher;
          const s = o.globalEventsController;
          const a = o.fullscreenToggler;
          const c = o.lightboxCloseActioner;
          const u = o.scrollbarRecompensor;
          const l = o.slideshowManager;
          const f = o.zoomer;
          const d = e.elements.container;
          const h = e.props;
          const p = e.sourcePointerProps;
          const m = e.timeout;
          const b = e.thumbsSwipingProps;
          (c.isLightboxFadingOut = !1),
            (c.runActions = function () {
              (c.isLightboxFadingOut = !0),
                d.current.classList.add('fslightbox-fade-out-strong'),
                s.removeListeners(),
                l.resetSlideshow(),
                h.exitFullscreenOnClose && r.get() && a.exitFullscreen(),
                f.ifZoomingResetZoom(),
                m(function () {
                  (c.isLightboxFadingOut = !1),
                    (p.isPointering = !1),
                    b && (b.isPointering = !1),
                    d.current.classList.remove('fslightbox-fade-out-strong'),
                    document.documentElement.classList.remove(
                      'fslightbox-open'
                    ),
                    u.removeRecompense(),
                    n.set(!1),
                    i.dispatch('onClose');
                }, 270);
            });
        })(e),
        Ge(e),
        (function (e) {
          const t = e.collections.sourceMainWrapperTransformers;
          const n = e.core;
          const r = n.eventsDispatcher;
          const o = n.lightboxOpenActioner;
          const i = n.globalEventsController;
          const s = n.scrollbarRecompensor;
          const a = n.sourceDisplayFacade;
          const c = n.stageManager;
          const u = n.windowResizeActioner;
          const l = e.data;
          const f = e.props.sources;
          const d = e.stageIndexes;
          o.runInitializedLightboxActions = function () {
            (l.unloadedThumbsCount = f.length),
              c.updateStageIndexes(),
              a.displaySourcesWhichShouldBeDisplayed(),
              document.documentElement.classList.add('fslightbox-open'),
              s.addRecompense(),
              i.addListeners(),
              u.runActions(),
              t[d.current].zero(),
              r.dispatch('onOpen');
          };
        })(e),
        ee(e),
        (function (e) {
          const t = e.data;
          const n = e.core.scrollbarRecompensor;
          n.addRecompense = function () {
            document.readyState === 'complete'
              ? r()
              : window.addEventListener('load', function () {
                  r(), (n.addRecompense = r);
                });
          };
          var r = function () {
            document.body.offsetHeight > window.innerHeight &&
              (document.body.style.marginRight = `${t.scrollbarWidth}px`);
          };
          n.removeRecompense = function () {
            document.body.style.removeProperty('margin-right');
          };
        })(e),
        xe(e),
        (function (e) {
          const t = e.core;
          const n = t.slideChangeFacade;
          const r = t.slideIndexChanger;
          const o = t.stageManager;
          e.props.sources.length > 1
            ? ((n.changeToPrevious = function () {
                r.jumpTo(o.getPreviousSlideIndex());
              }),
              (n.changeToNext = function () {
                r.jumpTo(o.getNextSlideIndex());
              }))
            : ((n.changeToPrevious = function () {}),
              (n.changeToNext = function () {}));
        })(e),
        (function (e) {
          const t = e.collections.sourceMainWrapperTransformers;
          const n = e.componentsServices;
          const r = e.core;
          const o = r.classFacade;
          const i = r.eventsDispatcher;
          const s = r.slideIndexChanger;
          const a = r.sourceDisplayFacade;
          const c = r.stageManager;
          const u = r.thumbsTransformer;
          const l = r.zoomer;
          const f = e.data;
          const d = e.elements;
          const h = d.sourceAnimationWrappers;
          const p = d.sources;
          const m = d.thumbs;
          const b = e.getQueuedAction;
          const g = e.props;
          const v = g.disableThumbs;
          const x = g.initialAnimation;
          const y = g.slideChangeAnimation;
          const w = e.resolve;
          const S = e.stageIndexes;
          const A = e.timeout;
          const T = w(we);
          const L = b(function () {
            o.removeFromEachElementClassIfContains(
              'sourceAnimationWrappers',
              'fslightbox-fade-out'
            );
          }, 300);
          (s.changeTo = function (e) {
            v ||
              (m[S.current].current &&
                m[S.current].current.classList.remove(
                  'fslightbox-thumb-active'
                ),
              m[e].current &&
                m[e].current.classList.add('fslightbox-thumb-active')),
              l.ifZoomingResetZoom(),
              f.isThumbing || T.runSlideChangeActions(S.current, e),
              (S.current = e),
              c.updateStageIndexes(),
              !v &&
                m[S.current].current &&
                u.transformToCurrentWithTransition(),
              n.setSlideNumber(e + 1),
              a.displaySourcesWhichShouldBeDisplayed(),
              i.dispatch('onSlideChange');
          }),
            (s.jumpTo = function (e) {
              const n = S.current;
              o.removeFromEachElementClassIfContains(
                'sourceMainWrappers',
                'fslightbox-transform-transition'
              ),
                ye(h[n], x),
                ye(h[n], y),
                h[n].current.classList.add('fslightbox-fade-out'),
                ye(h[e], x),
                ye(h[e], 'fslightbox-fade-out'),
                p[e].current && h[e].current.classList.add(y),
                s.changeTo(e),
                L(),
                t[e].zero(),
                A(function () {
                  n !== S.current && t[n].negative();
                }, 270);
            });
        })(e),
        (function (e) {
          const t = e.core.sourceEnhancementWrappersTransformer;
          const n = e.data;
          const r = (0, e.resolve)(He);
          (t.ifSourceIsLoadedTransformEnhancementWrapperAtIndex = function (e) {
            n.isThumbing
              ? r.setUpThumbedEnhancementWrapperTransform()
              : r.setUpNotThumbedEnhancementWrapperTransformAtIndex(e),
              r.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(e);
          }),
            (t.ifSourceIsLoadedTransformThumbedEnhancementWrapperAtIndex =
              function (e) {
                r.setUpThumbedEnhancementWrapperTransform(e),
                  r.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(e);
              }),
            (t.ifSourceIsLoadedTransformNotThumbedEnhancementWrapperAtIndex =
              function (e) {
                r.setUpNotThumbedEnhancementWrapperTransformAtIndex(e),
                  r.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(e);
              });
        })(e),
        (function (e) {
          const t = e.core.sourceDisplayFacade;
          const n = e.componentsServices.updateSourceDirectWrapperCollection;
          const r = e.stageIndexes;
          const o = e.props.loadOnlyCurrentSource;
          t.displaySourcesWhichShouldBeDisplayed = function () {
            if (o) n[r.current]();
            else for (const e in r) void 0 !== r[e] && n[r[e]]();
          };
        })(e),
        (function (e) {
          const t = e.core;
          const n = t.classFacade;
          const r = t.sourcesPointerDown;
          const o = t.pointeringBucket;
          const i = e.elements.sources;
          const s = e.resolve;
          const a = e.sourcePointerProps;
          const c = e.stageIndexes;
          const u = s(ve);
          r.listener = function (e) {
            e.pointerType !== 'touch' &&
              e.target.tagName !== 'VIDEO' &&
              e.preventDefault(),
              o.runSwipingDownActionsForPropsAndEvent(a, e),
              (a.downScreenY = e.screenY),
              a.pointersCount === 2
                ? u.runPinchActions()
                : n.removeFromEachElementClassIfContains(
                    'sourceMainWrappers',
                    'fslightbox-transform-transition'
                  );
            const t = i[c.current].current;
            t && t.contains(e.target)
              ? (a.isSourceDownEventTarget = !0)
              : (a.isSourceDownEventTarget = !1);
          };
        })(e),
        (function (e) {
          const t = e.stageIndexes;
          const n = e.core.stageManager;
          const r = e.props.sources.length - 1;
          (n.getPreviousSlideIndex = function () {
            return t.current === 0 ? r : t.current - 1;
          }),
            (n.getNextSlideIndex = function () {
              return t.current === r ? 0 : t.current + 1;
            }),
            (n.updateStageIndexes =
              r === 0
                ? function () {}
                : r === 1
                ? function () {
                    t.current === 0
                      ? ((t.next = 1), delete t.previous)
                      : ((t.previous = 0), delete t.next);
                  }
                : function () {
                    (t.previous = n.getPreviousSlideIndex()),
                      (t.next = n.getNextSlideIndex());
                  }),
            (n.isSourceInStage =
              r <= 2
                ? function () {
                    return !0;
                  }
                : function (e) {
                    const n = t.current;
                    if ((n === 0 && e === r) || (n === r && e === 0)) return !0;
                    const o = n - e;
                    return o === -1 || o === 0 || o === 1;
                  });
        })(e),
        (function (e) {
          const t = e.core.pointeringBucket;
          const n = e.elements.container;
          (t.runSwipingDownActionsForPropsAndEvent = function (e, t) {
            (e.isPointering = !0), (e.downScreenX = t.screenX), (e.swipedX = 0);
          }),
            (t.runSwipingMoveActionsForPropsAndEvent = function (e, t) {
              ge(n, 'fslightbox-cursor-grabbing'),
                (e.swipedX = t.screenX - e.downScreenX);
            }),
            (t.runSwipingTopActionsForPropsAndEvent = function (e) {
              ye(n, 'fslightbox-cursor-grabbing'), (e.isPointering = !1);
            });
        })(e),
        (function (e) {
          const t = e.collections;
          const n = t.sourceMainWrapperTransformers;
          const r = t.sourceSizers;
          const o = e.core;
          const i = o.sourceEnhancementWrappersTransformer;
          const s = o.windowResizeActioner;
          const a = o.thumbsTransformer;
          const c = e.data;
          const u = e.elements;
          const l = u.captions;
          const f = u.sourceMainWrappers;
          const d = u.sources;
          const h = u.thumbs;
          const p = u.thumbsContainer;
          const m = e.props.disableThumbs;
          const b = e.stageIndexes;
          const g = c.captionHeights;
          const v = c.notThumbedSourceEnhancementWrapperScales;
          const x = c.notThumbedSourceEnhancementWrapperTranslatesY;
          (s.runActions = function () {
            innerWidth < 992
              ? (c.maxSourceWidth = innerWidth)
              : (c.maxSourceWidth = 0.9 * innerWidth),
              (c.maxSourceHeight = 0.9 * innerHeight),
              m ||
                ((c.thumbedSourceEnhancementWrapperScale =
                  1 - p.current.offsetHeight / innerHeight),
                (c.thumbedSourceEnhancementWrapperTranslateY =
                  -p.current.offsetHeight / 2)),
              c.unloadedThumbsCount === 0 && s.runThumbsActions();
            for (let e = 0; e < d.length; e++) {
              if (l[e].current) {
                g[e] = l[e].current.offsetHeight;
                const t = g[e] - 25;
                (v[e] = 1 - t / innerHeight), (x[e] = -t / 2);
              } else (v[e] = 1), (x[e] = 0);
              ye(f[e], 'fslightbox-transform-transition'),
                i.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(e),
                e !== b.current && n[e].negative(),
                r[e] && d[e].current && r[e].adjustSize();
            }
          }),
            (s.runThumbsActions = function () {
              c.thumbsInnerWidth = 0;
              for (let e = 0; e < d.length; e++)
                c.thumbsInnerWidth += h[e].current.offsetWidth + 8;
              a.transformToCurrent();
            });
        })(e),
        (function (e) {
          const t = e.collections.sourceMainWrapperTransformers;
          const n = e.core;
          const r = n.eventsDispatcher;
          const o = n.zoomer;
          const i = e.data;
          const s = e.elements;
          const a = s.sourceMainWrappers;
          const c = s.sourceWrappersContainer;
          const u = s.sources;
          const l = e.resolve;
          const f = e.sourcePointerProps;
          const d = e.stageIndexes;
          const h = l(Be);
          (o.zoomTo = function (e) {
            (i.zoom = m(e)), (c.current.style.transform = `scale(${i.zoom})`);
          }),
            (o.ifZoomingResetZoom = function () {
              i.zoom !== 1 && (o.zoomTo(1), o.endZooming());
            }),
            (o.startZooming = function () {
              p('grab'),
                h.runOpacity0ActionUsingMethod('add'),
                h.runActiveEnhancementActionUsingMethod('remove'),
                r.dispatch('onZoomingStart');
            }),
            (o.endZooming = function () {
              p('zoom-in'),
                h.runOpacity0ActionUsingMethod('remove'),
                h.runActiveEnhancementActionUsingMethod('add'),
                a[d.current].current.classList.add(
                  'fslightbox-transform-transition'
                ),
                t[d.current].translate(0, 0).zero(),
                (f.upSwipedX = 0),
                (f.upSwipedY = 0),
                r.dispatch('onZoomingEnd');
            });
          var p = function (e) {
            u[d.current].current && (u[d.current].current.style.cursor = e);
          };
          var m = function (e) {
            return parseFloat(e.toPrecision(12));
          };
        })(e);
    }
    function Ue(e) {
      for (var t = e.props.sources, n = [], r = 0; r < t.length; r++)
        n.push(a.a.createRef());
      return n;
    }
    function De(e) {
      const t = e.core;
      const n = t.sourceEnhancementWrappersTransformer;
      const r = t.thumbsRenderDispatcher;
      const o = t.zoomer;
      const i = e.data;
      const s = e.elements;
      const a = s.captions;
      const c = s.thumbsContainer;
      const u = e.props.sources;
      const l = e.stageIndexes;
      function f() {
        for (let e = 0; e < u.length; e++)
          n.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(e);
      }
      function d(e) {
        a[l.current].current &&
          a[l.current].current.classList[e]('fslightbox-caption-active');
      }
      (this.openThumbs = function () {
        o.ifZoomingResetZoom(),
          (i.isThumbing = !0),
          c.current.classList.add('fslightbox-thumbs-active'),
          f(),
          d('remove'),
          r.renderThumbsIfNotYetAndAllBuilt();
      }),
        (this.closeThumbs = function () {
          o.ifZoomingResetZoom(),
            (i.isThumbing = !1),
            c.current.classList.remove('fslightbox-thumbs-active'),
            f(),
            d('add');
        });
    }
    function Ye(e) {
      const t = e.data;
      const n = e.elements;
      const r = n.thumbsWrappers;
      const o = n.thumbsContainer;
      const i = n.thumbsInner;
      const s = e.stageIndexes;
      const a = e.timeout;
      (this.runActions = function () {
        ye(o, 'fslightbox-flex-centered');
        const e = innerWidth / 2;
        const n = r[s.current].current;
        const i = n.offsetLeft + n.offsetWidth / 2;
        const a = t.thumbsInnerWidth - i;
        i > e && a > e
          ? c(e - i)
          : i > e
          ? c(innerWidth - t.thumbsInnerWidth - 9)
          : a > e && c(0);
      }),
        (this.runToThinThumbsActions = function () {
          a(function () {
            return ge(o, 'fslightbox-flex-centered');
          }),
            c(0);
        });
      var c = function (e) {
        (t.thumbsTransform = e),
          (i.current.style.transform = `translateX(${e}px)`);
      };
    }
    function Xe(e) {
      let t;
      let n;
      let r;
      let o;
      let i;
      const s = e.componentsServices;
      const c = e.core;
      const u = e.data;
      const l = e.elements;
      const f = e.props;
      (s.updateThumbsInner = null),
        (s.showThumbsCursorerIfNotYet = null),
        (s.hideThumbsCursorerIfShown = null),
        (s.hideThumbsLoader = null),
        (u.isThumbing = f.showThumbsOnMount),
        (u.thumbsInnerWidth = null),
        (u.thumbsTransform = 0),
        (u.thumbedSourceEnhancementWrapperScale = null),
        (u.thumbedSourceEnhancementWrapperTranslateY = null),
        (u.unloadedThumbsCount = null),
        (e.thumbsSwipingProps = {
          isPointering: !1,
          downScreenX: null,
          swipedX: null,
        }),
        (c.thumbLoadHandler = {}),
        (c.thumbsRenderDispatcher = {}),
        (c.thumbsSwipingDown = {}),
        (c.thumbsToggler = {}),
        (c.thumbsTransformer = {}),
        (c.thumbsTransformTransitioner = {}),
        (l.thumbsContainer = a.a.createRef()),
        (l.thumbs = Ue(e)),
        (l.thumbsWrappers = Ue(e)),
        (l.thumbsComponents = []),
        (l.thumbsInner = a.a.createRef()),
        (function (e) {
          const t = e.core;
          const n = t.thumbLoadHandler;
          const r = t.windowResizeActioner;
          const o = e.componentsServices;
          const i = e.data;
          const s = e.elements.thumbsWrappers;
          n.handleLoad = function () {
            if ((i.unloadedThumbsCount--, i.unloadedThumbsCount === 0)) {
              for (let e = 0; e < s.length; e++)
                s[e].current.classList.add('fslightbox-opacity-1');
              r.runThumbsActions(), o.hideThumbsLoader();
            }
          };
        })(e),
        (function (e) {
          const t = e.componentsServices;
          const n = e.core.thumbsRenderDispatcher;
          const r = e.props.sources;
          let o = !1;
          let i = 0;
          (n.countBuiltThumb = function () {
            i++;
          }),
            (n.renderThumbsIfNotYetAndAllBuilt = function () {
              o || i !== r.length || ((o = !0), t.updateThumbsInner());
            });
        })(e),
        (n = (t = e).core),
        (r = n.thumbsSwipingDown),
        (o = n.pointeringBucket),
        (i = t.thumbsSwipingProps),
        (r.listener = function (e) {
          e.preventDefault(), o.runSwipingDownActionsForPropsAndEvent(i, e);
        }),
        (function (e) {
          const t = e.core;
          const n = t.thumbsTransformer;
          const r = t.thumbsTransformTransitioner;
          const o = e.data;
          const i = (0, e.resolve)(Ye);
          (n.transformToCurrent = function () {
            o.thumbsInnerWidth > innerWidth
              ? i.runActions()
              : i.runToThinThumbsActions();
          }),
            (n.transformToCurrentWithTransition = function () {
              o.thumbsInnerWidth > innerWidth &&
                r.callActionWithTransition(i.runActions);
            });
        })(e),
        (function (e) {
          const t = e.core.thumbsTransformTransitioner;
          const n = e.elements.thumbsInner;
          const r = (0, e.getQueuedAction)(function () {
            n.current.classList.remove('fslightbox-transform-transition');
          }, 300);
          t.callActionWithTransition = function (e) {
            n.current.classList.add('fslightbox-transform-transition'),
              e(),
              r();
          };
        })(e),
        (function (e) {
          const t = e.core.thumbsToggler;
          const n = e.data;
          const r = (0, e.resolve)(De);
          t.toggleThumbs = function () {
            n.isThumbing ? r.closeThumbs() : r.openThumbs();
          };
        })(e);
    }
    function Ze(e) {
      return (Ze =
        typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                typeof Symbol === 'function' &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? 'symbol'
                : typeof e;
            })(e);
    }
    function Ve(e, t) {
      if (Ze(t) === 'object')
        for (const n in e)
          Ze(t[n]) === 'object' ? Ve(e[n], t[n]) : t[n] && (e[n] = t[n]);
    }
    function _e(e, t, n) {
      for (let r = 0; r < e.props.sources.length; r++)
        e.collections[t][r] = e.resolve(n, [r]);
    }
    function qe(e, t, n, r) {
      const o = e.data;
      const i = e.elements.sources;
      const s = n / r;
      let a = 0;
      this.adjustSize = function () {
        if ((a = o.maxSourceWidth / s) < o.maxSourceHeight)
          return n < o.maxSourceWidth && (a = r), c();
        (a = r > o.maxSourceHeight ? o.maxSourceHeight : r), c();
      };
      var c = function () {
        const e = i[t].current.style;
        (e.width = `${a * s}px`), (e.height = `${a}px`);
      };
    }
    function $e(e, t) {
      const n = this;
      const r = e.collections.sourceSizers;
      const o = e.componentsServices.hideSourceLoaderCollection;
      const i = e.core.sourceEnhancementWrappersTransformer;
      const s = e.elements;
      const a = s.sourceAnimationWrappers;
      const c = s.sourceEnhancementWrappers;
      const u = s.sources;
      const l = e.props.initialAnimation;
      const f = e.resolve;
      function d(e, n) {
        (r[t] = f(qe, [t, e, n])), r[t].adjustSize();
      }
      this.runActions = function (e, r) {
        u[t].current.classList.add('fslightbox-opacity-1'),
          a[t].current.classList.add(l),
          o[t](),
          i.ifSourceIsLoadedTransformEnhancementWrapperAtIndex(t),
          c[t].current.offsetWidth,
          c[t].current.classList.add('fslightbox-transform-transition'),
          d(e, r),
          (n.runActions = d);
      };
    }
    function Qe(e, t) {
      let n;
      const r = this;
      const o = e.elements.sources;
      const i = e.props;
      const s = e.resolve;
      const a = e.timeout;
      const c = s($e, [t]);
      (this.handleImageLoad = function (e) {
        const t = e.target;
        const n = t.naturalWidth;
        const r = t.naturalHeight;
        c.runActions(n, r);
      }),
        (this.handleVideoLoad = function (e) {
          const t = e.target;
          const r = t.videoWidth;
          const o = t.videoHeight;
          (n = !0), c.runActions(r, o);
        }),
        (this.handleNotMetaDatedVideoLoad = function () {
          n || r.handleYoutubeLoad();
        }),
        (this.handleYoutubeLoad = function () {
          let e = 1920;
          let t = 1080;
          i.maxYoutubeVideoDimensions &&
            ((e = i.maxYoutubeVideoDimensions.width),
            (t = i.maxYoutubeVideoDimensions.height)),
            c.runActions(e, t);
        }),
        (this.handleCustomLoad = function () {
          a(function () {
            const e = o[t].current;
            c.runActions(e.offsetWidth, e.offsetHeight);
          });
        });
    }
    function Je(e, t) {
      const n = this;
      const r = e.elements.sourceMainWrappers;
      const o = e.props.slideDistance;
      let i = 0;
      let s = 0;
      let a = 0;
      (this.translate = function (e, t) {
        return (s = e), void 0 !== t && (a = t), n;
      }),
        (this.getTranslateX = function () {
          return i;
        }),
        (this.getTranslateY = function () {
          return a;
        }),
        (this.negative = function () {
          c(-(1 + o) * innerWidth);
        }),
        (this.zero = function () {
          c(0);
        }),
        (this.positive = function () {
          c((1 + o) * innerWidth);
        });
      var c = function (e) {
        (i = e + s), u(), (s = 0);
      };
      var u = function () {
        r[t].current.style.transform = `translate(${i}px, ${a}px)`;
      };
    }
    function Ge(e) {
      const t = e.componentsServices.isLightboxOpenManager;
      const n = e.core;
      const r = n.eventsDispatcher;
      const o = n.lightboxOpener;
      const i = n.lightboxOpenActioner;
      const s = e.data;
      const a = e.elements;
      const c = e.props;
      (o.open = function () {
        r.dispatch('onShow'),
          _e(e, 'sourceLoadHandlers', Qe),
          t.set(!0, i.runInitializedLightboxActions);
      }),
        (o.initializeAndOpen = function () {
          (s.isInitialized = !0),
            (a.captions = Ue(e)),
            (a.sourceAnimationWrappers = Ue(e)),
            (a.sourceEnhancementWrappers = Ue(e)),
            (a.sourceMainWrappers = Ue(e)),
            (a.sources = Ue(e)),
            _e(e, 'sourceLoadHandlers', Qe),
            _e(e, 'sourceMainWrapperTransformers', Je),
            Ve(s.slideButtons, c.svg.slideButtons),
            Ve(s.toolbarButtons, c.svg.toolbarButtons),
            c.disableThumbs || Xe(e),
            Re(e),
            r.dispatch('onInit'),
            t.set(!0, function () {
              i.runInitializedLightboxActions(),
                (function (e) {
                  for (
                    let t = e.props.sources,
                      n = e.resolve,
                      r = n(te),
                      o = n(he),
                      i = n(me, [r, o]),
                      s = 0;
                    s < t.length;
                    s++
                  )
                    if (typeof t[s] === 'string') {
                      const a = i.getTypeSetByClientForIndex(s);
                      if (a) o.runActionsForSourceTypeAndIndex(a, s);
                      else {
                        const c = r.getSourceTypeFromLocalStorageByUrl(t[s]);
                        c
                          ? o.runActionsForSourceTypeAndIndex(c, s)
                          : i.retrieveTypeWithXhrForIndex(s);
                      }
                    } else o.runActionsForSourceTypeAndIndex('custom', s);
                })(e);
            });
        });
    }
    function Ke(e) {
      return (
        (function (e) {
          if (Array.isArray(e)) return et(e);
        })(e) ||
        (function (e) {
          if (
            (typeof Symbol !== 'undefined' && e[Symbol.iterator] != null) ||
            e['@@iterator'] != null
          )
            return Array.from(e);
        })(e) ||
        (function (e, t) {
          if (!e) return;
          if (typeof e === 'string') return et(e, t);
          let n = Object.prototype.toString.call(e).slice(8, -1);
          n === 'Object' && e.constructor && (n = e.constructor.name);
          if (n === 'Map' || n === 'Set') return Array.from(e);
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return et(e, t);
        })(e) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        })()
      );
    }
    function et(e, t) {
      (t == null || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    const tt = {
      thumbs: {
        width: '17px',
        height: '17px',
        viewBox: '0 0 22 22',
        d: 'M 3 2 C 2.448 2 2 2.448 2 3 L 2 6 C 2 6.552 2.448 7 3 7 L 6 7 C 6.552 7 7 6.552 7 6 L 7 3 C 7 2.448 6.552 2 6 2 L 3 2 z M 10 2 C 9.448 2 9 2.448 9 3 L 9 6 C 9 6.552 9.448 7 10 7 L 13 7 C 13.552 7 14 6.552 14 6 L 14 3 C 14 2.448 13.552 2 13 2 L 10 2 z M 17 2 C 16.448 2 16 2.448 16 3 L 16 6 C 16 6.552 16.448 7 17 7 L 20 7 C 20.552 7 21 6.552 21 6 L 21 3 C 21 2.448 20.552 2 20 2 L 17 2 z M 3 9 C 2.448 9 2 9.448 2 10 L 2 13 C 2 13.552 2.448 14 3 14 L 6 14 C 6.552 14 7 13.552 7 13 L 7 10 C 7 9.448 6.552 9 6 9 L 3 9 z M 10 9 C 9.448 9 9 9.448 9 10 L 9 13 C 9 13.552 9.448 14 10 14 L 13 14 C 13.552 14 14 13.552 14 13 L 14 10 C 14 9.448 13.552 9 13 9 L 10 9 z M 17 9 C 16.448 9 16 9.448 16 10 L 16 13 C 16 13.552 16.448 14 17 14 L 20 14 C 20.552 14 21 13.552 21 13 L 21 10 C 21 9.448 20.552 9 20 9 L 17 9 z M 3 16 C 2.448 16 2 16.448 2 17 L 2 20 C 2 20.552 2.448 21 3 21 L 6 21 C 6.552 21 7 20.552 7 20 L 7 17 C 7 16.448 6.552 16 6 16 L 3 16 z M 10 16 C 9.448 16 9 16.448 9 17 L 9 20 C 9 20.552 9.448 21 10 21 L 13 21 C 13.552 21 14 20.552 14 20 L 14 17 C 14 16.448 13.552 16 13 16 L 10 16 z M 17 16 C 16.448 16 16 16.448 16 17 L 16 20 C 16 20.552 16.448 21 17 21 L 20 21 C 20.552 21 21 20.552 21 20 L 21 17 C 21 16.448 20.552 16 20 16 L 17 16 z',
        title: 'Thumbnails',
      },
      zoomIn: {
        width: '20px',
        height: '20px',
        viewBox: '0 0 30 30',
        d: 'M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z M 12.984375 7.9863281 A 1.0001 1.0001 0 0 0 12 9 L 12 12 L 9 12 A 1.0001 1.0001 0 1 0 9 14 L 12 14 L 12 17 A 1.0001 1.0001 0 1 0 14 17 L 14 14 L 17 14 A 1.0001 1.0001 0 1 0 17 12 L 14 12 L 14 9 A 1.0001 1.0001 0 0 0 12.984375 7.9863281 z',
        title: 'Zoom In',
      },
      zoomOut: {
        width: '20px',
        height: '20px',
        viewBox: '0 0 30 30',
        d: 'M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z M 9 12 A 1.0001 1.0001 0 1 0 9 14 L 17 14 A 1.0001 1.0001 0 1 0 17 12 L 9 12 z',
        title: 'Zoom Out',
      },
      slideshow: {
        start: {
          width: '16px',
          height: '16px',
          viewBox: '0 0 30 30',
          d: 'M 6 3 A 1 1 0 0 0 5 4 A 1 1 0 0 0 5 4.0039062 L 5 15 L 5 25.996094 A 1 1 0 0 0 5 26 A 1 1 0 0 0 6 27 A 1 1 0 0 0 6.5800781 26.8125 L 6.5820312 26.814453 L 26.416016 15.908203 A 1 1 0 0 0 27 15 A 1 1 0 0 0 26.388672 14.078125 L 6.5820312 3.1855469 L 6.5800781 3.1855469 A 1 1 0 0 0 6 3 z',
          title: 'Turn on slideshow',
        },
        pause: {
          width: '14px',
          height: '14px',
          viewBox: '0 0 356.19 356.19',
          d: 'M121,0c18,0,33,15,33,33v372c0,18-15,33-33,33s-32-15-32-33V33C89,15,103,0,121,0zM317,0c18,0,32,15,32,33v372c0,18-14,33-32,33s-33-15-33-33V33C284,15,299,0,317,0z',
          title: 'Turn off slideshow',
        },
      },
      fullscreen: {
        enter: {
          width: '20px',
          height: '20px',
          viewBox: '0 0 18 18',
          d: 'M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z',
          title: 'Enter fullscreen',
        },
        exit: {
          width: '24px',
          height: '24px',
          viewBox: '0 0 950 1024',
          d: 'M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z',
          title: 'Exit fullscreen',
        },
      },
      close: {
        width: '20px',
        height: '20px',
        viewBox: '0 0 24 24',
        d: 'M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z',
        title: 'Close',
      },
    };
    const nt = {
      previous: {
        width: '20px',
        height: '20px',
        viewBox: '0 0 20 20',
        d: 'M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z',
        title: 'Previous',
      },
      next: {
        width: '20px',
        height: '20px',
        viewBox: '0 0 20 20',
        d: 'M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z',
        title: 'Next',
      },
    };
    function rt(e) {
      const t = e.additionalClassName;
      const n = e.reference;
      const r = e.onClick;
      const o = e.viewBox;
      const i = e.width;
      const s = e.height;
      const c = e.d;
      const u = e.title;
      return a.a.createElement(
        'div',
        {
          ref: n,
          onClick: r,
          title: u,
          className: `fslightbox-slide-btn-container ${t}`,
        },
        a.a.createElement(
          'div',
          { className: 'fslightbox-slide-btn fslightbox-flex-centered' },
          a.a.createElement(l, { viewBox: o, width: i, height: s, d: c })
        )
      );
    }
    function ot() {
      return (ot =
        Object.assign ||
        function (e) {
          for (let t = 1; t < arguments.length; t++) {
            const n = arguments[t];
            for (const r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
    }
    function it(e) {
      const t = e.fsLightbox;
      const n = t.core.slideChangeFacade;
      const r = n.changeToPrevious;
      const o = n.changeToNext;
      const i = t.data.slideButtons;
      const s = i.previous;
      const c = i.next;
      const u = t.elements;
      const l = u.slideButtonPrevious;
      const f = u.slideButtonNext;
      return (
        t.props.sources.length > 1 &&
        a.a.createElement(
          a.a.Fragment,
          null,
          a.a.createElement(rt, {
            reference: l,
            additionalClassName: 'fslightbox-slide-btn-container-previous',
            onClick: r,
            ...s,
          }),
          a.a.createElement(rt, {
            reference: f,
            additionalClassName: 'fslightbox-slide-btn-container-next',
            onClick: o,
            ...c,
          })
        )
      );
    }
    function st(e) {
      return (st =
        typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                typeof Symbol === 'function' &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? 'symbol'
                : typeof e;
            })(e);
    }
    function at(e, t, n) {
      return (at = pt()
        ? Reflect.construct
        : function (e, t, n) {
            const r = [null];
            r.push.apply(r, t);
            const o = new (Function.bind.apply(e, r))();
            return n && ft(o, n.prototype), o;
          }).apply(null, arguments);
    }
    function ct(e) {
      return (
        (function (e) {
          if (Array.isArray(e)) return ut(e);
        })(e) ||
        (function (e) {
          if (
            (typeof Symbol !== 'undefined' && e[Symbol.iterator] != null) ||
            e['@@iterator'] != null
          )
            return Array.from(e);
        })(e) ||
        (function (e, t) {
          if (!e) return;
          if (typeof e === 'string') return ut(e, t);
          let n = Object.prototype.toString.call(e).slice(8, -1);
          n === 'Object' && e.constructor && (n = e.constructor.name);
          if (n === 'Map' || n === 'Set') return Array.from(e);
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return ut(e, t);
        })(e) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        })()
      );
    }
    function ut(e, t) {
      (t == null || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function lt(e, t) {
      for (let n = 0; n < t.length; n++) {
        const r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function ft(e, t) {
      return (ft =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function dt(e, t) {
      return !t || (st(t) !== 'object' && typeof t !== 'function') ? ht(e) : t;
    }
    function ht(e) {
      if (void 0 === e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return e;
    }
    function pt() {
      if (typeof Reflect === 'undefined' || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if (typeof Proxy === 'function') return !0;
      try {
        return (
          Boolean.prototype.valueOf.call(
            Reflect.construct(Boolean, [], function () {})
          ),
          !0
        );
      } catch (e) {
        return !1;
      }
    }
    function mt(e) {
      return (mt = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    const bt = (function (e) {
      !(function (e, t) {
        if (typeof t !== 'function' && t !== null)
          throw new TypeError(
            'Super expression must either be null or a function'
          );
        (e.prototype = Object.create(t && t.prototype, {
          constructor: { value: e, writable: !0, configurable: !0 },
        })),
          t && ft(e, t);
      })(u, e);
      let t;
      let n;
      let o;
      let i;
      let s;
      const c =
        ((t = u),
        (n = pt()),
        function () {
          let e;
          const r = mt(t);
          if (n) {
            const o = mt(this).constructor;
            e = Reflect.construct(r, arguments, o);
          } else e = r.apply(this, arguments);
          return dt(this, e);
        });
      function u(e) {
        let t;
        return (
          (function (e, t) {
            if (!(e instanceof t))
              throw new TypeError('Cannot call a class as a function');
          })(this, u),
          ((t = c.call(this, e)).state = { isOpen: !1 }),
          (t.data = {
            isInitialized: !1,
            maxSourceWidth: 0,
            maxSourceHeight: 0,
            scrollbarWidth: 0,
            toolbarButtons: tt,
            slideButtons: nt,
            captionHeights: [],
            notThumbedSourceEnhancementWrapperScales: [],
            notThumbedSourceEnhancementWrapperTranslatesY: [],
            thumbedSourceEnhancementWrapperTranslateY: null,
            zoom: 1,
          }),
          (t.sourcePointerProps = {
            isPointering: !1,
            pointers: {},
            pointersCount: 0,
            downScreenX: null,
            downScreenY: null,
            isSourceDownEventTarget: !1,
            swipedX: 0,
            swipedY: 0,
            upSwipedX: 0,
            upSwipedY: 0,
            pinchedHypot: 0,
          }),
          (t.stageIndexes = { current: 0 }),
          (t.componentsServices = {
            showSlideSwipingHovererIfNotYet: null,
            hideSlideSwipingHoverer: null,
            hideSourceLoaderCollection: [],
            updateSourceDirectWrapperCollection: [],
            isFullscreenOpen: {},
            startSlideshow: null,
            stopSlideshow: null,
            isSlideShowOn: {},
            slideNumberUpdater: {},
            toolbarButtons: { fullscreen: {}, slideshow: {} },
            isLightboxOpenManager: {
              get() {
                return t.state.isOpen;
              },
              set(e, n) {
                t.setState({ isOpen: e }, n);
              },
            },
          }),
          (t.elements = {
            captions: null,
            container: a.a.createRef(),
            nav: a.a.createRef(),
            slideButtonPrevious: a.a.createRef(),
            slideButtonNext: a.a.createRef(),
            slideshowBar: a.a.createRef(),
            sourceAnimationWrappers: null,
            sourceEnhancementWrappers: null,
            sourceMainWrappers: null,
            sourceWrappersContainer: a.a.createRef(),
            sources: null,
            sourceComponents: [],
          }),
          (t.core = {
            classFacade: {},
            clickZoomer: {},
            eventsDispatcher: {},
            fullscreenToggler: {},
            globalEventsController: {},
            inactiver: {},
            lightboxCloser: {},
            lightboxCloseActioner: {},
            lightboxOpener: {},
            lightboxOpenActioner: {},
            lightboxUpdater: {},
            scrollbarRecompensor: {},
            slideshowManager: {},
            slideChangeFacade: {},
            slideIndexChanger: {},
            sourceEnhancementWrappersTransformer: {},
            sourceDisplayFacade: {},
            sourcesPointerDown: {},
            stageManager: {},
            pointeringBucket: {},
            windowResizeActioner: {},
            zoomer: {},
          }),
          (t.collections = {
            sourceMainWrapperTransformers: [],
            sourceLoadHandlers: [],
            sourceSizers: [],
            xhrs: [],
          }),
          (t.getQueuedAction = t.getQueuedAction.bind(ht(t))),
          (t.middleware = t.middleware.bind(ht(t))),
          (t.resolve = t.resolve.bind(ht(t))),
          (t.timeout = t.timeout.bind(ht(t))),
          ee(ht(t)),
          Ge(ht(t)),
          t
        );
      }
      return (
        (o = u),
        (i = [
          {
            key: 'getQueuedAction',
            value(e, t) {
              const n = this;
              const r = [];
              return function () {
                r.push(!0),
                  n.timeout(function () {
                    r.pop(), r.length || e();
                  }, t);
              };
            },
          },
          {
            key: 'middleware',
            value(e, t) {
              return (function (e, t) {
                const n =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : [];
                return function () {
                  for (
                    var r = arguments.length, o = new Array(r), i = 0;
                    i < r;
                    i++
                  )
                    o[i] = arguments[i];
                  t.apply(void 0, Ke(n.concat(o))) && e.apply(void 0, o);
                };
              })(e, t, [this]);
            },
          },
          {
            key: 'resolve',
            value(e) {
              const t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : [];
              return t.unshift(this), at(e, ct(t));
            },
          },
          {
            key: 'timeout',
            value(e, t) {
              const n = this;
              setTimeout(function () {
                n.elements.container.current && e();
              }, t);
            },
          },
          {
            key: 'componentDidUpdate',
            value(e) {
              this.core.lightboxUpdater.handleUpdate(e);
            },
          },
          {
            key: 'componentDidMount',
            value() {
              R(this);
            },
          },
          {
            key: 'componentWillUnmount',
            value() {
              !(function (e) {
                for (
                  var t = e.collections.xhrs,
                    n = e.componentsServices.isLightboxOpenManager,
                    r = e.core.globalEventsController,
                    o = 0;
                  o < t.length;
                  o++
                )
                  t[o].abort();
                n.get() && r.removeListeners();
              })(this);
            },
          },
          {
            key: 'render',
            value() {
              return this.state.isOpen
                ? a.a.createElement(
                    'div',
                    {
                      className: `${r}container fslightbox-full-dimension fslightbox-fade-in-strong`,
                      ref: this.elements.container,
                    },
                    a.a.createElement(B, { fsLightbox: this }),
                    a.a.createElement(L, { fsLightbox: this }),
                    a.a.createElement(U, { fsLightbox: this }),
                    a.a.createElement(it, { fsLightbox: this }),
                    a.a.createElement(F, { fsLightbox: this }),
                    a.a.createElement(G, { fsLightbox: this }),
                    this.props.disableThumbs
                      ? null
                      : a.a.createElement(Q, { fsLightbox: this })
                  )
                : null;
            },
          },
        ]) && lt(o.prototype, i),
        s && lt(o, s),
        u
      );
    })(s.Component);
    (bt.propTypes = {
      toggler: u.a.bool,
      sources: u.a.array,
      initialAnimation: u.a.string,
      slideChangeAnimation: u.a.string,
      captions: u.a.array,
      onOpen: u.a.func,
      onClose: u.a.func,
      onInit: u.a.func,
      onShow: u.a.func,
      onSlideChange: u.a.func,
      onZoomingStart: u.a.func,
      onZoomingEnd: u.a.func,
      source: u.a.string,
      sourceIndex: u.a.number,
      slide: u.a.number,
      customAttributes: u.a.array,
      maxYoutubeVideoDimensions: u.a.object,
      svg: u.a.object,
      disableLocalStorage: u.a.bool,
      types: u.a.array,
      type: u.a.string,
      thumbs: u.a.array,
      disableThumbs: u.a.bool,
      showThumbsOnMount: u.a.bool,
      thumbsIcons: u.a.array,
      customToolbarButtons: u.a.array,
      exitFullscreenOnClose: u.a.bool,
      loadOnlyCurrentSource: u.a.bool,
      openOnMount: u.a.bool,
      slideDistance: u.a.number,
      slideshowTime: u.a.number,
      UIFadeOutTime: u.a.number,
      zoomIncrement: u.a.number,
    }),
      (bt.defaultProps = {
        svg: {},
        initialAnimation: 'fslightbox-fade-in-strong',
        slideChangeAnimation: 'fslightbox-fade-in',
        slideDistance: 0.3,
        slideshowTime: 8e3,
        UIFadeOutTime: 8e3,
        zoomIncrement: 0.25,
      });
    t.default = bt;
  },
]);
